import { Typography } from 'glintly-ui';
import styles from './dashboardContainer.module.css';

const DashboardContainer = ({ children, title, subtitle }) => {
  return (
    <div className={styles.dashboardContainer}>
      <div className={styles.pageHeader}>
        <div>
          <Typography fontSize="2.25rem" variant="h4" className={styles.pageTitle}>
            {title}
          </Typography>
        </div>
        <Typography variant="body1" className={styles.pageSubtitle}>
          {subtitle}
        </Typography>
      </div>
      {children}
    </div>
  );
};

export default DashboardContainer;
